import React from "react";

export function CallMonitor() {
  return (
    <svg
      width="512"
      height="512"
      viewBox="0 0 512 512"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="CallMonitor">
        <g id="Frame">
          <path
            id="Vector"
            d="M418.133 68.2657H401.066V102.398C401.066 104.664 401.965 106.832 403.566 108.434L420.633 125.5L432.699 113.434L418.133 98.8673V68.2657Z"
            fill="#055C5A"
          />
          <path
            id="Vector 2"
            d="M409.602 9.18805e-05C380.527 0.0196231 352.844 12.4376 333.492 34.1329H68.2656C49.4141 34.1329 34.1328 49.4141 34.1328 68.2657V366.934C34.1328 385.785 49.4141 401.066 68.2656 401.066H190.293L157.105 460.801H110.934C96.793 460.801 85.332 472.262 85.332 486.398C85.332 500.539 96.793 512 110.934 512H401.066C415.207 512 426.668 500.539 426.668 486.398C426.668 472.262 415.207 460.801 401.066 460.801H354.883L321.707 401.066H443.734C462.586 401.066 477.867 385.785 477.867 366.934V178.508C519.98 140.883 523.617 76.2423 485.992 34.129C466.562 12.379 438.766 -0.0389706 409.602 9.18805e-05ZM409.602 486.402C409.602 491.113 405.781 494.934 401.066 494.934H110.934C106.219 494.934 102.398 491.113 102.398 486.402C102.398 481.687 106.219 477.867 110.934 477.867H401.066C405.781 477.867 409.602 481.687 409.602 486.402ZM335.359 460.801H176.641L209.828 401.066H302.184L335.359 460.801ZM460.801 366.934C460.801 376.359 453.16 384 443.734 384H68.2656C58.8398 384 51.1992 376.359 51.1992 366.934V332.801H460.801V366.934ZM157.414 197.164C149.824 193.406 145.031 185.656 145.066 177.187V128C145.066 109.148 160.348 93.8673 179.199 93.8673C198.051 93.8673 213.332 109.148 213.332 128V177.187C213.367 185.656 208.578 193.406 200.984 197.164C198.094 198.609 196.266 201.566 196.266 204.801V221.867C196.266 225.781 198.93 229.195 202.727 230.145L245.145 240.742C256.543 243.594 264.535 253.836 264.531 265.582V315.734H247.465V281.602H230.398V315.734H128V281.602H110.934V315.734H93.8672V265.582C93.8633 253.836 101.859 243.594 113.254 240.742L155.672 230.145C159.469 229.191 162.133 225.781 162.133 221.867V204.801C162.133 201.566 160.309 198.609 157.414 197.164ZM460.801 315.734H281.602V265.582C281.621 245.996 268.289 228.918 249.285 224.187L213.332 215.203V209.656C224.043 202.34 230.434 190.199 230.398 177.23V128C230.398 99.7227 207.477 76.8009 179.199 76.8009C150.922 76.8009 128 99.7227 128 128V177.187C127.953 190.172 134.344 202.332 145.066 209.656V215.203L109.117 224.187C90.1094 228.918 76.7773 245.996 76.8008 265.582V315.734H51.1992V68.2657C51.1992 58.8399 58.8398 51.1993 68.2656 51.1993H321.059C292.68 100 309.23 162.562 358.031 190.941C389.797 209.418 429.035 209.418 460.801 190.941V315.734ZM409.602 187.734C362.473 187.734 324.266 149.527 324.266 102.398C324.266 55.2735 362.473 17.0665 409.602 17.0665C456.73 17.0665 494.934 55.2735 494.934 102.402C494.883 149.508 456.707 187.684 409.602 187.734Z"
            fill="#055C5A"
          />
          <path
            id="Vector 3"
            d="M401.066 34.1329H418.133V51.1993H401.066V34.1329Z"
            fill="#055C5A"
          />
          <path
            id="Vector 4"
            d="M355.305 60.1485L367.371 48.0743L379.441 60.1407L367.379 72.2149L355.305 60.1485Z"
            fill="#055C5A"
          />
          <path
            id="Vector 5"
            d="M341.332 93.8673H358.398V110.934H341.332V93.8673Z"
            fill="#055C5A"
          />
          <path
            id="Vector 6"
            d="M355.309 144.625L367.383 132.559L379.449 144.633L367.375 156.699L355.309 144.625Z"
            fill="#055C5A"
          />
          <path
            id="Vector 7"
            d="M401.066 153.602H418.133V170.668H401.066V153.602Z"
            fill="#055C5A"
          />
          <path
            id="Vector 8"
            d="M439.785 144.629L451.852 132.555L463.926 144.621L451.859 156.695L439.785 144.629Z"
            fill="#055C5A"
          />
          <path
            id="Vector 9"
            d="M460.801 93.8673H477.867V110.934H460.801V93.8673Z"
            fill="#055C5A"
          />
          <path
            id="Vector 10"
            d="M439.789 60.1446L451.863 48.0782L463.926 60.1525L451.855 72.2149L439.789 60.1446Z"
            fill="#055C5A"
          />
          <path
            id="Vector 11"
            d="M110.934 17.0665V0.00012207H59.7344C26.7578 0.0391846 0.0390625 26.7618 0 59.7345V230.398H17.0664V59.7345C17.0938 36.1798 36.1797 17.0939 59.7344 17.0665H110.934Z"
            fill="#055C5A"
          />
          <path
            id="Vector 12"
            d="M0 247.469H17.0664V264.535H0V247.469Z"
            fill="#055C5A"
          />
          <path
            id="Vector 13"
            d="M494.934 221.867H512V358.402H494.934V221.867Z"
            fill="#055C5A"
          />
          <path
            id="Vector 14"
            d="M307.199 238.934H324.266V256H307.199V238.934Z"
            fill="#055C5A"
          />
          <path
            id="Vector 15"
            d="M341.332 238.934H435.199V256H341.332V238.934Z"
            fill="#055C5A"
          />
          <path
            id="Vector 16"
            d="M307.199 273.066H435.199V290.133H307.199V273.066Z"
            fill="#055C5A"
          />
          <path
            id="Vector 17"
            d="M247.469 349.867H264.535V366.934H247.469V349.867Z"
            fill="#055C5A"
          />
        </g>
      </g>
    </svg>
  );
}
